import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Image, SafeAnchor } from '@hydra/common/components';
import { CriteriumSkeleton } from '@hydra/common/criterium';
import { useReviewContext } from '@hydra/common/context';

import settings from '@hydra/utils/settings';
import { getTechnologyLink } from '@hydra/utils/getWooIndexLink';

const useStyles = makeStyles(theme => ({
  root: {
    margin: theme.spacing(0.5, 1, 0.5, 0),
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.fontSizeSmall,
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1.5),
    backgroundColor: theme.palette.grey[100]
  },
  image: {
    width: 15,
    backgroundColor: theme.palette.grey[100]
  }
}));

export const CriteriumTechnologyBadge = ({ id, app }) => {
  const { isPdf } = useReviewContext();
  const classes = useStyles();
  const link = getTechnologyLink(id);
  const imageSrc = new URL(`/tech-icons/${id}.png`, settings.get('cdnUrl')).href;
  const { variant } = useReviewContext();

  return (
    <>
      {
        variant === 'nocrit'
          ? <CriteriumSkeleton width='10%' style={{ margin: '5px' }} />
          : (
            <Button
              key={id}
              variant='outlined'
              className={classes.root}
              startIcon={<Image width={15} height={15} defer={!isPdf} className={classes.image} src={imageSrc} />}
            >
              {
                isPdf
                  ? app
                  : (
                    <SafeAnchor href={link} rel='nofollow noopener noreferrer' target='_blank'>
                      {app}
                    </SafeAnchor>
                    )
              }
            </Button>
            )
      }
    </>
  );
};

CriteriumTechnologyBadge.propTypes = {
  id: PropTypes.string,
  app: PropTypes.string
};

export default CriteriumTechnologyBadge;
